import { AdminPageShell } from "../components/index.js";
import { ReportDetail } from "../features/reports/index.js";
import { useT } from "../i18n/index.js";

export function ReportDetailPage() {
  const t = useT();
  return (
    <AdminPageShell
      crumbs={[
        { label: t("admin.reports"), to: "/admin/reports" },
        { label: t("admin.detail") },
      ]}
    >
      <ReportDetail />
    </AdminPageShell>
  );
}
